import { EventHandlerConfig } from "@/widgetLibrary/interface"

export const TIMELINE_EVENT_HANDLER_CONFIG: EventHandlerConfig = {
  events: [],
  methods: ["setValue", "clearValue"],
}
